import { render, staticRenderFns } from "./KioskFooter.vue?vue&type=template&id=70c0a028&"
import script from "./KioskFooter.vue?vue&type=script&lang=js&"
export * from "./KioskFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports